module.exports = __webpack_public_path__ + "assets/img/btn-info-64d774ee.png";